import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// The name of our affiliate query parameter in the URL (e.g., yoursite.com?ref=CODE)
const AFFILIATE_PARAM = 'ref'; 
// The key we'll use to store the code in localStorage
const STORAGE_KEY = 'affiliateCode';

/**
 * A custom hook to detect an affiliate code from the URL query parameters
 * and persist it in localStorage.
 */
const useAffiliateTracker = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check if the 'ref' param exists in the URL
    const affiliateCode = searchParams.get(AFFILIATE_PARAM);

    if (affiliateCode) {
      // If a code is found in the URL, we store it.
      // This will overwrite any existing code, ensuring the latest affiliate link takes precedence.
      console.log(`Affiliate code detected: ${affiliateCode}. Saving to storage.`);
      localStorage.setItem(STORAGE_KEY, affiliateCode);
    }
    // We only want this effect to run when the search parameters change.
  }, [searchParams]);
};

export default useAffiliateTracker;